export default "__VITE_ASSET__Wrbo3xie__"